import script from "./DocumentPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentPage.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentPage.vue?vue&type=style&index=0&id=b4dab10e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4dab10e"]])

export default __exports__